export type CompareField = {
    fieldName: string;
    route?: string | null;
    unit?: string | null;
    type?: string;
}

export const COMPARE_FIELD_TYPES = {
    HTML: "html",
    SUM: "sum",
    NUMERAL: "numeral"
}

const CompareFields: Record<string, CompareField | null> = {
    COMP_GLOBAL_INFO: null, //CAPTION
    COMP_UE: {
        fieldName: "heatpump_type",
        route: "product",
    },
    COMP_MOD_HYDRAU: {
        fieldName: "heatpump_DHWtype",
        route: "product",
    },
    COMP_COOLING: {
        fieldName: "heatpump_cooling",
        route: "product",
    },
    COMP_STRENGTH: {
        fieldName: "heatpump_strength",
        route: "product",
        type: COMPARE_FIELD_TYPES.HTML,
    },
    COMP_RUNNING_INFO: null,
    COMP_THERMO_COV_RATE: {
        fieldName: "TxCouvThermo",
        unit: "%",
    },
    COMP_THERMO_POWER: {
        fieldName: "Pcalotb",
        unit: "kW",

    },
    COMP_BIV_POINT: {
        fieldName: "Tbiv",
        unit: "°C",
    },
    COMP_ANNUAL_CONSO_HEAT: {
        fieldName: "PACChCost",
        route: "E3",
        unit: "currency",
        type: COMPARE_FIELD_TYPES.SUM //SUM OF E3.PACChCost
    },
    EXTRA_ELEC: {
        fieldName: "AppointAvailable",
        unit: "kW",
        type: COMPARE_FIELD_TYPES.NUMERAL
    },
    NEEDED_EXTRA_ELEC: {
        fieldName: "AppointNeeded",
        unit: "kW",
        type: COMPARE_FIELD_TYPES.NUMERAL
    },
    COMP_TECHNICAL_PERF: null,
    COMP_NRJ_CLASS_55: {
        fieldName: "heatpump_energyclass55",
        route: "product",
        unit: "°C"
    },
    COMP_ETA_55: {
        fieldName: "heatpump_eta55",
        route: "product",
        unit: "%"
    },
    COMP_SCOP_55: {
        fieldName: "heatpump_scop55",
        route: "product",
        unit: "°C"
    },
    COMP_NRJ_CLASS_35: {
        fieldName: "heatpump_energyclass35",
        route: "product",
        unit: "°C"
    },
    COMP_ETA_35: {
        fieldName: "heatpump_eta35",
        route: "product",
        unit: "%"
    },
    COMP_SCOP_35: {
        fieldName: "heatpump_scop35",
        route: "product",
        unit: "°C"
    },
    COMP_ACOUSTIC_POWER_UE: {
        fieldName: "heatpump_acousticUE",
        route: "product",
    },
    COMP_ACOUSTIC_POWER_UI: {
        fieldName: "heatpump_acousticUI",
        route: "product",
    },
    COMP_IHM_CONNECTIVITY: null,
    COMP_IHM: {
        fieldName: "heatpump_IHM",
        route: "product",
    },
    COMP_CONNECTIVITY: {
        fieldName: "heatpump_connectivity",
        route: "product",
    },
    COMP_THERMOSTAT: {
        fieldName: "heatpump_thermostat",
        route: "product",
    },
    COMP_HYDRAULIC: null,
    COMP_EXPANSION_TANK_CAPACITY: {
        fieldName: "heatpump_expansioncapacity",
        route: "product",
    },

    COMP_INSTALLATION_CAPACITY: {
        fieldName: "heatpump_installationcapacity",
        route: "product",
    },
    COMP_DHW: null,
    COMP_DHW_CAPACITY_TANK: {
        fieldName: "heatpump_DHWcapacitytank",
        route: "product",
    },
    COMP_DHW_MATERIAL_TANK: {
        fieldName: "heatpump_DHWmaterialtank",
        route: "product",
    },
    COMP_DHW_NRJ_CLASS_TANK: {
        fieldName: "heatpump_DHWenergyclasstank",
        route: "product",
    },
    COMP_DHW_COP: {
        fieldName: "heatpump_DHWcop",
        route: "product",
    },
    COMP_DHW_ANNUAL_CONSO: {
        fieldName: "PacdwhCost",
        route: "E3",
        unit: "currency",
        type: COMPARE_FIELD_TYPES.SUM //SUM OF E3.PACDWHCost
    },
    COMP_SIZE: null,
    COMP_DIMENSIONS_UE: {
        fieldName: "heatpump_dimensionUE",
        route: "product",
        unit: "mm",
    },

    COMP_WEIGHT_UE: {
        fieldName: "heatpump_weightUE",
        route: "product",
        unit: "kg",
    },

    COMP_DIMENSIONS_UI: {
        fieldName: "heatpump_dimensionUI",
        route: "product",
        unit: "mm",
    },

    COMP_WEIGHT_UI: {
        fieldName: "heatpump_weightUI",
        route: "product",
        unit: "kg",
    },

    COMP_LINK_DISTANCE_UIUE: {
        fieldName: "heatpump_distanceUIUE",
        route: "product",
        unit: "m",
    },

    COMP_LINK_DROP_UIUE: {
        fieldName: "heatpump_dropUIUE",
        route: "product",
        unit: "m",
    },

    COMP_LINK_DIAMETER: {
        fieldName: "heatpump_diameterlink",
        route: "product",
        unit: "mm",
    },

}

export default CompareFields;